import { clsx } from 'clsx';

import { getInputGrid, showByConditionalLogic } from '@monoimin/utils/helpers';

import { Icons } from '../icons';

import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const CheckboxGravityForm = ({
  checkboxLabel,
  choices,
  adminLabel,
  isRequired,
  formValuesById,
  conditionalLogic,
  visibility,
  customId,
  layoutGridColumnSpan = 12,
  classNames,
}: InputProps) => {
  if (!Array.isArray(choices)) return null;

  const show = conditionalLogic
    ? showByConditionalLogic({ conditionalLogic, formValuesById })
    : true;
  if (!show || visibility === 'hidden') return null;

  const label = checkboxLabel || choices?.[0]?.text || '';
  const valueText = choices?.[0]?.value;

  const gridColumn = getInputGrid(layoutGridColumnSpan);
  return (
    <div
      className={clsx(
        `flex gap-4 cursor-pointer`,
        classNames?.input,
        gridColumn
      )}
      data-testid='checkbox-gravity-form'
    >
      <label
        className={clsx(
          'checkbox bg-white relative border border-line rounded-sm',
          classNames?.inputWrapper
        )}
        htmlFor={customId}
      >
        <input
          id={customId}
          type='checkbox'
          className='peer absolute appearance-none opacity-0'
          required={isRequired}
          name={adminLabel || customId}
          value={valueText}
        />
        <Icons
          icon='checkmark'
          isInteractive
          className='duration-100 opacity-0 peer-checked:opacity-100 absolute'
          sizeClassName={classNames?.icon}
        />
      </label>

      {/* eslint-disable-next-line */}
      <label
        htmlFor={customId}
        className={clsx(
          'cursor-pointer text-sm [&>a]:text-blue-400',
          classNames?.label
        )}
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
    </div>
  );
};
